// extracted by mini-css-extract-plugin
module.exports = {"meterContainer":"Calculator_meterContainer__ZpT_4","meterBackground":"Calculator_meterBackground__No5wv","meterNeedle":"Calculator_meterNeedle__3SWWC"};